import {Component, OnInit} from '@angular/core';
import {SimpleUser, User, UserService} from "../../../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {firstValueFrom} from "rxjs";
import {Invite, InviteService} from "../../../services/invite.service";
import {marked} from "marked";
import {Page} from "../../../services/api.service";
import { PageEvent, MatPaginatorModule } from "@angular/material/paginator";
import {getMissingFields, hasValidEmail, ProfileField} from "../../../services/profile-requirements.service";
import { UserSummaryComponent } from '../../../components/user-summary/user-summary.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { ProfileFieldsComponent } from '../../../components/profile-fields/profile-fields.component';
import { EmailSuffixesComponent } from '../../../components/email-suffixes/email-suffixes.component';
import { AvatarComponent } from '../../../components/avatar/avatar.component';
import { NavbarComponent } from '../../../components/navbar/navbar.component';
import { NgIf, NgFor } from '@angular/common';
import { Enrollment } from 'src/app/services/enrollment.service';

@Component({
    selector: 'app-accept-invite',
    templateUrl: './accept-invite.component.html',
    styleUrls: ['./accept-invite.component.scss'],
    standalone: true,
    imports: [NgIf, NavbarComponent, AvatarComponent, EmailSuffixesComponent, ProfileFieldsComponent, MatButtonModule, FaIconComponent, MatPaginatorModule, NgFor, UserSummaryComponent]
})
export class AcceptInviteComponent implements OnInit{

  loading: boolean = true ;
  inviteCode?: string ;
  invite?: Invite ;
  user?: User ;
  acceptance?: Enrollment ;

  loadingAcceptees: boolean = false ;
  acceptees?: Page<SimpleUser>;

  constructor(
    public users: UserService,
    public invites: InviteService,
    public route: ActivatedRoute,
    public router: Router
  ) {

  }

  public get selfieRequired(): boolean {

    if (!this.invite)
      return false ;

    if (!this.invite.requirements || !this.invite.requirements.fields) {
      return false ;
    }

    return this.invite.requirements.fields.includes('SELFIE');
  }

  async ngOnInit() {

    this.loading = true ;

    this.inviteCode = this.route.snapshot.params['inviteCode'] ;

    try {
      this.invite = await firstValueFrom(this.invites.getInvite(this.inviteCode!)) ;
    }
    catch (e) {
      this.router.navigateByUrl("/404", { skipLocationChange: true });
      return ;
    }

    try {
      this.user = await firstValueFrom(this.users.getUser());
      this.acceptance = await firstValueFrom(this.invites.getMyAcceptance(this.inviteCode!)) ;

      if (this.acceptance) {
        await this.loadAcceptees(0);
      }
    } catch (e) {
      //fail silently
      this.loading = false ;
    }
  }

  parse(markdown: string) {
    return marked.parse(markdown);
  }

  get hasInvalidEmail(): boolean {

    if (!this.user || !this.invite)
      return false ;

    return !hasValidEmail(this.user, this.invite.requirements);

  }

  get missingProfileFields(): ProfileField[] {
    if (!this.user || !this.invite)
      return [] ;

    return getMissingFields(this.user, this.invite.requirements);
  }

  get accepted(): boolean {
    return !!this.acceptance ;
  }

  signIn() {
    this.router.navigate([`auth`], { queryParams: {mode: 'signin', returnUrl: '/invite/' + this.inviteCode}});
  }

  editProfile() {
    this.router.navigate([`edit-profile`], { queryParams: {returnUrl: '/invite/' + this.inviteCode}});
  }

  async accept() {

    if (!this.user || !this.invite) {
      return ;
    }

    if (this.hasInvalidEmail || this.missingProfileFields.length > 0) {
      return ;
    }

    this.acceptance = await firstValueFrom(this.invites.acceptInvite(this.inviteCode!)) ;

    await this.loadAcceptees(0);
  }

  async loadAcceptees(page: number) {

    this.loadingAcceptees = true ;

    const results = await firstValueFrom(this.invites.getAcceptances(this.inviteCode!, page));

    console.log(results);
    this.acceptees = results ;

    this.loadingAcceptees = false ;
  }

  handlePageEvent($event: PageEvent) {
    this.loadAcceptees($event.pageIndex);
  }


}
